<template>
<v-card flat >
  <v-card-title class='overline' v-text='title' />
  <v-card-text class='pa-5'>
    <v-btn outline rounded x-large block color='primary' class='mb-3' style='border-radius: 25px;'
      v-for='option in options'
      :key='option.id'
      @click='setSelected(option)' >
      {{option.text}}
    </v-btn>
  </v-card-text>
  <v-dialog v-model='dialog' width='300' >
    <v-card v-if='selected && selected.prompt' >
      <v-card-title class='overline' v-if='selected.prompt.title' v-text='selected.prompt.title' >
      </v-card-title>
      <v-card-text v-if='selected.prompt.description' v-text='selected.prompt.description' />
      </v-card-text>
      <v-card-actions v-if='selected.prompt' >
        <v-spacer></v-spacer>
        <v-btn @click='dialog=false;$emit("selected", selected)' >{{ selected.prompt.done || "Got it" }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-card>
</template>

<script>
export default {
  name: 'Decision',
  props: {
    title: { type: String, required: true },
    options: { type: Array, required: true },
    description: { type: String, required: false }
  },
  data () {
    return {
      dialog: false,
      selected: {}
    }
  },
  methods: {
    setSelected (option) {
      if (option.prompt) {
        this.selected = option
        this.dialog = true
      } else {
        this.$emit('selected', option)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Decision.vue?43f4bf4d